const Fonts = {
    poppins:"font-family: 'Poppins', sans-serif;",
    jetBrains:"font-family: 'JetBrains Mono', monospace;"
}

export default Fonts